/* Bottom sheet de reseñas — se abre desde "Ver reseñas" en la fila de
   estrellas del fold (patrón Aguacero, diseccionado en vivo el 2026-08-07).

   LOS DATOS NO SE DUPLICAN: lee los <script type="application/json"> que ya
   emite el muro de la sección 17 ([data-skr-list], [data-skr-data]) y respeta
   su orden de DESTACADAS (data-skr-featured, curación de la sesión 5) y su
   media redondeada (data-skr-avg-override). Si el muro no está en la página,
   el gatillo se oculta solo y nada revienta.

   Scroll infinito DE VERDAD: la referencia usa botón "Cargar más"; aquí un
   IntersectionObserver sobre un centinela dentro del cuerpo scrolleable va
   añadiendo lotes de 18. Filtros Todas / Con fotos / Sin fotos re-renderizan
   desde el array ya parseado.

   SESIÓN 9 — SEGUNDA FUENTE: se intercalan las 37 reseñas curadas de Amazon
   México (assets/js-reviews-amazon.js, window.SKRS_AMAZON). Dictado de Mau:
   "primero las de la página, que las de arriba están buenísimas, y luego uno
   que otro de Amazon a lo largo de toda la lista". Traducido: LEAD tarjetas
   puras de Revie y después una de Amazon cada `step`, calculado para que las
   37 cubran los 250 de Revie de punta a punta. El orden relativo de Revie NO
   se altera, así que la curación de destacadas de la sesión 5 sigue mandando.

   El texto de cada reseña entra por textContent (nunca innerHTML): el
   contenido viene de clientas y no se confía. */
(function () {
  'use strict';

  var PER = 18;
  /* Tarjetas de Revie antes de la primera externa. Con 250 de Revie y 57
     externas (37 Amazon + 20 Mercado Libre) el step sale 4: la primera
     externa cae en la posición 15, dentro del primer lote de 18. */
  var LEAD = 10;
  var root, sheet, grid, body, sentinel, moreEl, avgEl, countEl;
  var amzLogo = '';         /* URL del asset del logo, la pone el snippet */
  var amzLogoOk = false;    /* true solo si ese asset carga de verdad */
  var mlLogo = '';          /* idem, logo de Mercado Libre (PORT MX) */
  var mlLogoOk = false;
  var cols = [];            /* las dos columnas del masonry */
  var warmed = false;
  var list = null;          /* todas, en orden destacadas-primero */
  var filtered = [];
  var filter = 'all';
  var rendered = 0;
  var io = null;
  var lastFocused = null;
  var keydownHandler = null;
  var closeTimer = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function fdate(s) {
    var d = new Date(s);
    if (isNaN(d)) return '';
    /* Override VISUAL de año (Mau, 2026-08-07; mismo espíritu que el
       override de los 15 primeros del muro en sesión 7): las reseñas del
       import heredan fechas viejas, así que 2024 se muestra como 2025 y
       2025 como 2026 — PERO solo si el resultado no pasa de agosto (hoy
       es agosto de 2026: una reseña de sep-dic 2025 mostrada como 2026
       quedaría en el futuro, así que esas conservan su año). El dato
       real de Revie no se toca; es solo presentación. */
    var y = d.getFullYear();
    var m = d.getMonth(); /* 0-11; agosto = 7 */
    if (y === 2024) {
      y = 2025;
    } else if (y === 2025 && m <= 7) {
      y = 2026;
    }
    return d.getDate() + ' ' + MES[m] + ' ' + y;
  }

  /* Fecha SIN override: las de Amazon son reales y recientes (ene 2025 a jul
     2026), así que se pintan tal cual. Se construye con componentes locales a
     propósito: new Date('2025-02-12') es medianoche UTC y en husos negativos
     retrocede un día. */
  function fdateRaw(s) {
    var p = String(s).split('-');
    if (p.length !== 3) return '';
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    if (isNaN(d)) return '';
    return d.getDate() + ' ' + MES[d.getMonth()] + ' ' + d.getFullYear();
  }

  /* Miles con coma SIEMPRE ("5,203"), formato es-MX (PORT MX): Intl no
     agrupa números de 4 cifras y el estilo de la marca sí. */
  function miles(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* El | json de metafields legacy puede salir doble-encodeado (gotcha del
     muro): re-parsear si el primer parse da string. */
  function pj(el) {
    if (!el) return null;
    var d = JSON.parse(el.textContent);
    if (typeof d === 'string') d = JSON.parse(d);
    return d;
  }

  function keyOf(r) {
    return (((r.customer || {}).firstName) || '').trim() + '|' + String(r.createdAt || '').slice(0, 10);
  }

  function hasPhoto(r) {
    return !!(r.images && r.images.length && r.images[0] && r.images[0].src);
  }

  /* Las de Amazon, normalizadas a la forma que ya consume card(). El array
     de origen viene ordenado por prioridad (fuerza de prueba > credibilidad
     > frescura) y ese orden se respeta tal cual. */
  function loadAmazon() {
    var src = window.SKRS_AMAZON;
    if (!src || !src.length) return [];
    return src.map(function (r) {
      return {
        source: 'amz',
        customer: { firstName: r.n, lastName: '' },
        stars: r.s,
        comment: r.t,
        createdAt: r.d,
        images: null
      };
    });
  }

  /* PORT MX (2026-08-20) — TERCERA FUENTE: top 20 de Mercado Libre México
     (assets/js-reviews-ml.js, window.SKRS_ML; scrape del listing oficial,
     xlsx de Mau). Reseñas ANÓNIMAS en ML: sin nombre, el card cae al
     fallback "Clienta" del muro. La fecha viene relativa ("Hace 1 año") y
     se pinta tal cual. Verbatim: mismo contrato que las de Amazon. */
  function loadML() {
    var src = window.SKRS_ML;
    if (!src || !src.length) return [];
    return src.map(function (r) {
      return {
        source: 'ml',
        customer: { firstName: '', lastName: '' },
        stars: r.s,
        comment: r.t,
        createdAt: '',
        dateText: r.d || '',
        images: null
      };
    });
  }

  /* Alterna Amazon y Mercado Libre conservando el orden interno de cada
     fuente (ambas vienen priorizadas): así los dos sellos se reparten por
     toda la lista en vez de amontonarse por bloques. */
  function mergeExternals(a, b) {
    var out = [];
    var max = Math.max(a.length, b.length);
    for (var i = 0; i < max; i++) {
      if (i < a.length) out.push(a[i]);
      if (i < b.length) out.push(b[i]);
    }
    return out;
  }

  /* Revie manda al principio; Amazon se reparte por TODA la lista, no se
     amontona al final. El orden relativo de Revie queda intacto. */
  function interleave(revie, amz) {
    if (!amz.length) return revie;
    var out = revie.slice(0, LEAD);
    var rest = revie.slice(LEAD);
    var step = Math.max(1, Math.floor(rest.length / amz.length));
    var ri = 0, ai = 0;
    while (ri < rest.length || ai < amz.length) {
      for (var k = 0; k < step && ri < rest.length; k++) out.push(rest[ri++]);
      if (ai < amz.length) out.push(amz[ai++]);
    }
    return out;
  }

  /* Lee los datos del muro. Devuelve false si el muro no está. */
  function loadData() {
    if (list) return true;
    var wall = document.querySelector('[data-skr-root]');
    if (!wall) return false;
    var raw, data;
    try {
      raw = pj(wall.querySelector('[data-skr-list]'));
      data = pj(wall.querySelector('[data-skr-data]'));
    } catch (e) {
      return false;
    }
    if (!raw || !raw.length) return false;

    /* Destacadas primero, mismo criterio que el muro. */
    var FEAT = (wall.getAttribute('data-skr-featured') || '').split(';')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
    if (FEAT.length) {
      var rank = {};
      FEAT.forEach(function (k, i) { rank[k] = i; });
      raw = raw
        .map(function (r, i) { return { r: r, i: i }; })
        .sort(function (a, b) {
          var ra = rank[keyOf(a.r)]; if (ra === undefined) ra = FEAT.length + a.i;
          var rb = rank[keyOf(b.r)]; if (rb === undefined) rb = FEAT.length + b.i;
          return ra - rb;
        })
        .map(function (x) { return x.r; });
    }
    list = interleave(raw, mergeExternals(loadAmazon(), loadML()));

    var avg = (wall.getAttribute('data-skr-avg-override') || '').trim();
    if (!avg && data && data.reviewAverageValue) {
      avg = String(Math.round(parseFloat(data.reviewAverageValue) * 10) / 10);
    }
    if (avgEl) avgEl.textContent = avg || '';
    var count = data && data.reviewCount ? data.reviewCount : list.length;
    if (countEl) countEl.textContent = '+' + miles(count);
    return true;
  }

  function applyFilter() {
    if (filter === 'photos') filtered = list.filter(hasPhoto);
    else if (filter === 'nophotos') filtered = list.filter(function (r) { return !hasPhoto(r); });
    else filtered = list;
  }

  function stars(n) {
    var wrap = document.createElement('span');
    wrap.className = 'skrs__stars';
    var full = Math.max(0, Math.min(5, parseInt(n, 10) || 0));
    wrap.appendChild(document.createTextNode(new Array(full + 1).join('★')));
    if (full < 5) {
      var off = document.createElement('span');
      off.className = 'skrs__star-off';
      off.textContent = new Array(5 - full + 1).join('★');
      wrap.appendChild(off);
    }
    return wrap;
  }

  /* La marca de Amazon del sello. Mau (2026-08-07): donde iría la palabra
     "Amazon" va SOLO el logo. Pero el logotipo lo sube él aparte, así que por
     defecto se pinta la PALABRA (que es además la alternativa sin riesgo de
     marca) y solo se cambia por el logo cuando consta que el asset existe.

     El <img> NUNCA se mete a ciegas: con un src que da 404 quedaría un hueco
     vacío de 54x17. Y no vale fiarlo al onerror, porque con loading="lazy"
     el navegador ni intenta cargar lo que está fuera de vista y el error no
     llega nunca (cazado en QA, 2026-08-07). */
  function amzMark() {
    if (amzLogoOk) {
      var img = document.createElement('img');
      img.className = 'skrs__amz';
      img.alt = 'Amazon';
      img.width = 54;
      img.height = 17;
      img.decoding = 'async';
      img.src = amzLogo;
      return img;
    }
    var txt = document.createElement('span');
    txt.className = 'skrs__amz-txt';
    txt.textContent = 'Amazon';
    return txt;
  }

  /* Idem para Mercado Libre (PORT MX). Mismo contrato: palabra por defecto,
     logo solo cuando consta que el asset carga. */
  function mlMark() {
    if (mlLogoOk) {
      var img = document.createElement('img');
      img.className = 'skrs__ml';
      img.alt = 'Mercado Libre';
      img.width = 64;
      img.height = 16;
      img.decoding = 'async';
      img.src = mlLogo;
      return img;
    }
    var txt = document.createElement('span');
    txt.className = 'skrs__amz-txt skrs__ml-txt';
    txt.textContent = 'Mercado Libre';
    return txt;
  }

  function srcMark(r) {
    return r && r.source === 'ml' ? mlMark() : amzMark();
  }

  /* Una sola comprobación por página, fuera del DOM. Si el logo confirma
     tarde, se sustituyen las palabras ya pintadas para que no queden unas
     tarjetas con logo y otras con texto. */
  function probeAmzLogo() {
    if (amzLogo) {
      var probe = new Image();
      probe.onload = function () {
        amzLogoOk = true;
        Array.prototype.forEach.call(document.querySelectorAll('.skrs__amz-txt:not(.skrs__ml-txt)'), function (el) {
          if (el.parentNode) el.parentNode.replaceChild(amzMark(), el);
        });
      };
      probe.src = amzLogo;
    }
    /* PORT MX: mismo patrón para el logo de Mercado Libre. */
    if (mlLogo) {
      var probeMl = new Image();
      probeMl.onload = function () {
        mlLogoOk = true;
        Array.prototype.forEach.call(document.querySelectorAll('.skrs__ml-txt'), function (el) {
          if (el.parentNode) el.parentNode.replaceChild(mlMark(), el);
        });
      };
      probeMl.src = mlLogo;
    }
  }

  /* Sello de origen de las externas (Amazon o Mercado Libre). En la tienda
     MX ya no hace falta el prefijo "México ·" en la fecha: todas las
     fuentes son mexicanas (PORT MX). */
  function sourceStamp(r) {
    var foot = document.createElement('div');
    foot.className = 'skrs__source';

    var ver = document.createElement('span');
    ver.className = 'skrs__source-ver';
    ver.textContent = '✓ Compra verificada';

    foot.appendChild(srcMark(r));
    foot.appendChild(ver);
    return foot;
  }

  function card(r) {
    var isAmz = r.source === 'amz';
    var isMl = r.source === 'ml';
    var isExt = isAmz || isMl;
    var art = document.createElement('article');
    art.className = 'skrs__card' + (isExt ? ' skrs__card--amz' : '');

    if (hasPhoto(r)) {
      var img = document.createElement('img');
      img.className = 'skrs__img skrs__img--pending';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = 'Foto de la reseña';
      /* El hueco ya lo reserva el aspect-ratio del CSS, así que esto es sólo
         un fundido para que la foto no aparezca de golpe sobre el gris.
         onload Y onerror quitan el estado pendiente: pase lo que pase, la
         imagen nunca se queda invisible. */
      var revelar = function () { img.classList.remove('skrs__img--pending'); };
      img.onload = revelar;
      img.onerror = revelar;
      img.src = r.images[0].src;
      if (img.complete) revelar();
      art.appendChild(img);
    }

    var bodyEl = document.createElement('div');
    bodyEl.className = 'skrs__card-body';

    var row1 = document.createElement('div');
    row1.className = 'skrs__row1';
    var name = document.createElement('span');
    name.className = 'skrs__name';
    var fn = ((r.customer || {}).firstName || '').trim();
    var ln = ((r.customer || {}).lastName || '').trim();
    /* "Clienta" = el mismo fallback que usa el muro para reseñas sin
       nombre (14 en el import); sin él quedaba un hueco. */
    name.textContent = (fn + (ln ? ' ' + ln.charAt(0) + '.' : '')) || 'Clienta';
    row1.appendChild(name);
    /* Las de Amazon llevan su propio sello al pie, así que aquí no se repite
       el "✓ Verificada" de Revie: diría lo mismo dos veces. */
    if (!isExt) {
      var ver = document.createElement('span');
      ver.className = 'skrs__verified';
      ver.textContent = '✓ Verificada';
      row1.appendChild(ver);
    }

    var row2 = document.createElement('div');
    row2.className = 'skrs__row2';
    row2.appendChild(stars(r.stars));
    var date = document.createElement('span');
    date.className = 'skrs__date';
    date.textContent = isMl
      ? (r.dateText || '')
      : isAmz
        ? fdateRaw(r.createdAt)
        : fdate(r.createdAt);
    row2.appendChild(date);

    var text = document.createElement('p');
    text.className = 'skrs__text';
    text.textContent = (r.comment || '').trim();

    bodyEl.appendChild(row1);
    bodyEl.appendChild(row2);
    if (text.textContent) bodyEl.appendChild(text);
    if (isExt) bodyEl.appendChild(sourceStamp(r));
    art.appendChild(bodyEl);
    return art;
  }

  /* Dos columnas explícitas en vez de `columns: 2`. Cada tarjeta cae en la más
     corta EN ESE MOMENTO y ya no se mueve nunca: el lote siguiente solo alarga
     una columna por abajo. Con `columns` el navegador rebalanceaba el reparto
     entero en cada añadido y saltaba hasta lo que estabas leyendo. */
  function makeCols() {
    grid.textContent = '';
    cols = [document.createElement('div'), document.createElement('div')];
    for (var i = 0; i < cols.length; i++) {
      cols[i].className = 'skrs__col';
      grid.appendChild(cols[i]);
    }
  }

  /* offsetHeight es fiable aunque la foto no haya cargado, porque el hueco ya
     lo reserva el aspect-ratio del CSS. Por eso el render tiene que ocurrir con
     el sheet ya no-hidden: en display:none todo mediría 0 y las 18 tarjetas
     se apilarían en la primera columna. */
  function shorterCol() {
    return cols[0].offsetHeight <= cols[1].offsetHeight ? cols[0] : cols[1];
  }

  function renderBatch() {
    var end = Math.min(rendered + PER, filtered.length);
    for (var i = rendered; i < end; i++) shorterCol().appendChild(card(filtered[i]));
    rendered = end;
    var done = rendered >= filtered.length;
    if (moreEl) moreEl.hidden = done;
    if (done && io) io.disconnect();
    if (!filtered.length) {
      var empty = document.createElement('p');
      empty.className = 'skrs__empty';
      empty.textContent = 'No hay reseñas en este filtro.';
      grid.appendChild(empty);
    }
  }

  function resetAndRender() {
    makeCols();
    rendered = 0;
    applyFilter();
    renderBatch();
    body.scrollTop = 0;
    watchSentinel();
  }

  function watchSentinel() {
    if (io) io.disconnect();
    if (!('IntersectionObserver' in window)) {
      /* Sin IO: carga por scroll manual, comprobando al hacer scroll. */
      body.addEventListener('scroll', function onScroll() {
        if (rendered >= filtered.length) { body.removeEventListener('scroll', onScroll); return; }
        if (body.scrollTop + body.clientHeight > body.scrollHeight - 600) renderBatch();
      });
      return;
    }
    io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; }) && rendered < filtered.length) {
        renderBatch();
      }
    }, { root: body, rootMargin: '600px 0px' });
    io.observe(sentinel);
  }

  function trapFocus(e) {
    var focusables = Array.prototype.slice.call(sheet.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!focusables.length) { e.preventDefault(); sheet.focus(); return; }
    var first = focusables[0], last = focusables[focusables.length - 1], active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !sheet.contains(active)) { e.preventDefault(); last.focus(); }
    } else if (active === last || !sheet.contains(active)) {
      e.preventDefault(); first.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); }
    else if (e.key === 'Tab') trapFocus(e);
  }

  function open(trigger) {
    if (!root || (!root.hidden && !closeTimer)) return;
    if (!loadData()) return;
    if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    lastFocused = trigger || document.activeElement;

    /* Se DESOCULTA ANTES de pintar, a propósito. El reparto en dos columnas
       mide alturas, y en display:none todo mide 0. Se ve igual porque el sheet
       aún está en translateY(100%) y el backdrop en opacity 0: el usuario no
       nota nada, pero el layout ya es medible y las fotos empiezan a cargar
       durante los 300 ms que dura la subida. */
    root.hidden = false;

    if (!cols.length || filter !== 'all') {
      filter = 'all';
      syncPills();
      resetAndRender();
    }

    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.classList.add('skrs-modal-lock');
    keydownHandler = onKeydown;
    document.addEventListener('keydown', keydownHandler, true);
    (root.querySelector('[data-skrs-x]') || sheet).focus();
  }

  function close() {
    if (root.hidden || closeTimer) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('skrs-modal-lock');
    if (keydownHandler) { document.removeEventListener('keydown', keydownHandler, true); keydownHandler = null; }
    closeTimer = window.setTimeout(function () { closeTimer = null; root.hidden = true; }, 320);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  function syncPills() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-skrs-filter]'), function (p) {
      p.setAttribute('aria-pressed', p.getAttribute('data-skrs-filter') === filter ? 'true' : 'false');
    });
  }

  function boot() {
    root = document.querySelector('[data-skrs-root]');
    if (!root) return;
    sheet = root.querySelector('[data-skrs-sheet]');
    grid = root.querySelector('[data-skrs-grid]');
    body = root.querySelector('[data-skrs-body]');
    sentinel = root.querySelector('[data-skrs-sentinel]');
    moreEl = root.querySelector('[data-skrs-more]');
    avgEl = root.querySelector('[data-skrs-avg]');
    countEl = root.querySelector('[data-skrs-count]');
    amzLogo = root.getAttribute('data-skrs-amz-logo') || '';
    mlLogo = root.getAttribute('data-skrs-ml-logo') || '';
    probeAmzLogo();

    /* Sin muro de reseñas en la página no hay datos: se esconden los
       gatillos y este componente queda inerte. */
    if (!document.querySelector('[data-skr-root]')) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-skrs-open]'), function (t) {
        t.hidden = true;
      });
      return;
    }

    /* Precalentado por INTENCIÓN: en cuanto el dedo toca el gatillo (o el ratón
       se posa encima) se piden las fotos del primer lote. Da 100-300 ms de
       ventaja y al abrir ya están pintadas en vez de entrar sobre el gris.
       Se hace aquí y no en el boot a propósito: quien no abra las reseñas no
       se come 16 descargas en la página que más vende. */
    function warm() {
      if (warmed || !loadData()) return;
      warmed = true;
      applyFilter();
      for (var i = 0; i < Math.min(PER, filtered.length); i++) {
        if (hasPhoto(filtered[i])) {
          var pre = new Image();
          pre.decoding = 'async';
          pre.src = filtered[i].images[0].src;
        }
      }
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-skrs-open]')) warm();
      }, { passive: true, capture: true });
    });

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-skrs-open]') : null;
      if (t) { e.preventDefault(); open(t); return; }
      var c = e.target && e.target.closest ? e.target.closest('[data-skrs-close]') : null;
      if (c && root.contains(c)) close();
      var f = e.target && e.target.closest ? e.target.closest('[data-skrs-filter]') : null;
      if (f && root.contains(f)) {
        var val = f.getAttribute('data-skrs-filter');
        if (val !== filter) { filter = val; syncPills(); resetAndRender(); }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
